import React, { Component } from "react";
import styled from "styled-components";
import "../../styles/components/header/Header.css";
import { Fade } from "react-reveal";
import { NavLink, Link } from "react-router-dom";
import { greeting, settings } from "../../portfolio.js";
import SeoHeader from "../seoHeader/SeoHeader";

const onMouseEnter = (event, color) => {
  const el = event.target;
  el.style.backgroundColor = color;
};

const onMouseOut = (event) => {
  const el = event.target;
  el.style.backgroundColor = "transparent";
};

/* ─── Desktop Outline Nav Styled Component ────────────────────────── */
const NavWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  .nav-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 0;
  }

  .nav-btn {
    font-size: 14px;
    color: ${(props) => props.themeColors.text};
    font-family: "Google Sans Regular", "Inter", sans-serif;
    font-weight: 700;
    letter-spacing: 0.6px;
    cursor: pointer;
    position: relative;
    border: none;
    background: none;
    text-transform: uppercase;
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
    transition-duration: 400ms;
    transition-property: color;
    text-decoration: none;
    margin: 0 16px;
    padding: 4px 0;
  }

  .nav-btn:focus,
  .nav-btn:hover {
    color: ${(props) => props.themeColors.imageHighlight};
  }

  .nav-btn:focus:after,
  .nav-btn:hover:after {
    width: 100%;
    left: 0%;
  }

  .nav-btn:after {
    content: "";
    pointer-events: none;
    bottom: -4px;
    left: 50%;
    position: absolute;
    width: 0%;
    height: 2px;
    background-color: ${(props) => props.themeColors.imageHighlight};
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
    transition-duration: 400ms;
    transition-property: width, left;
  }
`;

/* ─── Responsive Menu Wrapper ────────────────────────────────────── */
const MenuWrapper = styled.ul`
  .desktop-nav-li {
    display: none;
  }
  .mobile-nav-li {
    display: block;
  }

  @media (min-width: 69em) {
    display: flex !important;
    align-items: center;
    margin-left: auto; /* Push menu to the right */
    order: 2;

    .desktop-nav-li {
      display: block;
    }
    .mobile-nav-li {
      display: none;
    }
  }
`;

/* ─── Always-Visible Theme Toggle Container ───────────────────────── */
const ThemeToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 10px;
  z-index: 100;
  position: relative;

  @media (min-width: 69em) {
    height: auto;
    padding: 0;
    margin-left: 20px;
    order: 3;
  }
`;

class Header extends Component {
  render() {
    const theme = this.props.theme;
    const link = settings.isSplash ? "/splash" : "home";
    return (
      <Fade top duration={1000} distance="20px">
        <SeoHeader />
        <div>
          <header className="header">
            <NavLink to={link} tag={Link} className="logo" style={{ order: 1 }}>
              <span style={{ color: theme.text }}> &lt;</span>
              <span className="logo-name" style={{ color: "#FF6B35" }}>
                {greeting.logo_name}
              </span>
              <span style={{ color: theme.text }}>/&gt;</span>
            </NavLink>
            <input className="menu-btn" type="checkbox" id="menu-btn" />

            <label
              className="menu-icon"
              htmlFor="menu-btn"
              style={{ color: theme.text }}
            >
              <span className="navicon"></span>
            </label>

            {/* Always-visible Theme Toggle on Top Right */}
            <ThemeToggleContainer>
              <label htmlFor="theme" className="theme">
                <span className="theme__toggle-wrap">
                  <input
                    id="theme"
                    className="theme__toggle"
                    type="checkbox"
                    role="switch"
                    name="theme"
                    value="dark"
                    checked={
                      theme.body === "#263238" ||
                      theme.body === "#1d0c41" ||
                      theme.body === "#000000" ||
                      theme.body === "#21052C" ||
                      theme.body === "#031E26" ||
                      theme.body === "#1D2A30"
                    }
                    onChange={this.props.onToggle}
                  />
                  <span className="theme__icon">
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                  </span>
                </span>
              </label>
            </ThemeToggleContainer>

            <MenuWrapper
              className="menu"
              style={{ backgroundColor: theme.body }}
            >
              {/* Desktop Outline Nav */}
              <li className="desktop-nav-li">
                <NavWrapper themeColors={theme}>
                  <div className="nav-container">
                    <NavLink
                      to="/home"
                      tag={Link}
                      activeStyle={{ fontWeight: "bold" }}
                      className="nav-btn"
                    >
                      Home
                    </NavLink>
                    <NavLink
                      to="/education"
                      tag={Link}
                      activeStyle={{ fontWeight: "bold" }}
                      className="nav-btn"
                    >
                      Education
                    </NavLink>
                    <NavLink
                      to="/experience"
                      tag={Link}
                      activeStyle={{ fontWeight: "bold" }}
                      className="nav-btn"
                    >
                      Experience
                    </NavLink>
                    <NavLink
                      to="/projects"
                      tag={Link}
                      activeStyle={{ fontWeight: "bold" }}
                      className="nav-btn"
                    >
                      Projects
                    </NavLink>
                    <NavLink
                      to="/contact"
                      tag={Link}
                      activeStyle={{ fontWeight: "bold" }}
                      className="nav-btn"
                    >
                      Contact
                    </NavLink>
                  </div>
                </NavWrapper>
              </li>

              {/* Mobile Nav Links */}
              <li className="mobile-nav-li">
                <NavLink
                  to="/home"
                  tag={Link}
                  activeStyle={{ fontWeight: "bold" }}
                  style={{ color: theme.text }}
                  onMouseEnter={(event) => onMouseEnter(event, theme.highlight)}
                  onMouseOut={(event) => onMouseOut(event)}
                >
                  Home
                </NavLink>
              </li>
              <li className="mobile-nav-li">
                <NavLink
                  to="/education"
                  tag={Link}
                  activeStyle={{ fontWeight: "bold" }}
                  style={{ color: theme.text }}
                  onMouseEnter={(event) => onMouseEnter(event, theme.highlight)}
                  onMouseOut={(event) => onMouseOut(event)}
                >
                  Education
                </NavLink>
              </li>
              <li className="mobile-nav-li">
                <NavLink
                  to="/experience"
                  tag={Link}
                  activeStyle={{ fontWeight: "bold" }}
                  style={{ color: theme.text }}
                  onMouseEnter={(event) => onMouseEnter(event, theme.highlight)}
                  onMouseOut={(event) => onMouseOut(event)}
                >
                  Experience
                </NavLink>
              </li>
              <li className="mobile-nav-li">
                <NavLink
                  to="/projects"
                  tag={Link}
                  activeStyle={{ fontWeight: "bold" }}
                  style={{ color: theme.text }}
                  onMouseEnter={(event) => onMouseEnter(event, theme.highlight)}
                  onMouseOut={(event) => onMouseOut(event)}
                >
                  Projects
                </NavLink>
              </li>
              <li className="mobile-nav-li">
                <NavLink
                  to="/contact"
                  tag={Link}
                  activeStyle={{ fontWeight: "bold" }}
                  style={{ color: theme.text }}
                  onMouseEnter={(event) => onMouseEnter(event, theme.highlight)}
                  onMouseOut={(event) => onMouseOut(event)}
                >
                  Contact Me
                </NavLink>
              </li>
            </MenuWrapper>
          </header>
        </div>
      </Fade>
    );
  }
}

export default Header;
